<template>
  <div class="datetime__component mb-2">
    <div class="grey lighten-4 pl-3 pr-3 datetime__radius">
      <p v-if="label != null && label.length > 0" v-html="label" class="caption mb-0 pt-2"></p>
      <div class="datetime__date">
        <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
          <v-text-field
            slot="activator"
            v-model="dateFormatted"
            @blur="date = parseDate(dateFormatted)"
            hide-details
            placeholder="Datum"
            :box="box"
          ></v-text-field>
          <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="datetime_time" v-if="!hideTime">
        <v-menu bottom max-height="200" :offset-y="true">
          <v-text-field
            slot="activator"
            v-model="timeFormatted"
            hint="Formát HH:MM"
            @blur="time=parseTime(timeFormatted)"
            :box="box"
            placeholder="Čas"
            hide-details
            small
            mask="time"
          ></v-text-field>
          <v-list>
            <template v-for="item in times">
              <v-list-tile @click="timeFormatted=item.value;time=parseTime(item.value)">
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  data () {
    return {
      date: null,
      dateFormatted: null,
      time: null,
      timeFormatted: null,
      menu1: false,
      menu2: false,
      times: [],
      init: true
    }
  },
  props: {
    box: Boolean,
    label: String,
    value: Number,
    hideTime: Boolean
  },
  mounted: function() {
    for (var $h = 8; $h <= 17; $h++) {
      for (var $m = 0; $m < 4; $m++) {
        this.times.push({
          text: $h.toString().padStart(2, '0') + ':' + ($m * 15).toString().padStart(2, '0'),
          value: $h.toString().padStart(2, '0') + ($m * 15).toString().padStart(2, '0')
        })
      }
    }
    if (this.value !== null) {
      var value = moment(new Date(this.value*1000)).format("YYYY-MM-DD HH:mm");
      const [d, t] = value.split(" ");
      this.date = d;
      this.dateFormatted = value;
      this.timeFormatted = t.replace(":", "");
      this.time = t;
    }
    this.init = false;
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate()
    }
  },
  watch: {
    date (val) {
      if (this.init) return;
      this.dateFormatted = this.formatDate()
      console.log(this.formatDateUniversal())
      this.$emit("input", this.formatDateUniversal());
    },
    time (val) {
      if (this.init) return;
      console.log(this.formatDateUniversal())
      if (this.dateFormatted && this.dateFormatted.length > 0)
        this.$emit("input", this.formatDateUniversal());
    }
  },
  methods: {
    formatDate () {
      if (!this.date) return null
      const [year, month, day] = this.date.split('-')
      return `${day}.${month}.${year}`
    },
    formatDateUniversal: function() {
      if (!this.date) return null;
      return parseInt(new Date(this.date + " " + this.time + ":00").getTime()/1000);
      /*const [year, month, day] = this.date.split('-');
      const time = this.time
      if (this.time != null && this.time.length > 0) {
        return `${year}-${month}-${day} ${time}:00`;
      }
      else
        return `${year}-${month}-${day}`;*/
    },
    parseDate () {
      if (!this.date) return null
      const [year, month, day] = this.date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseTime (time) {
      if (!time || time.length != 4) return null

      var h = parseInt(time.substr(0, 2))
      var m = parseInt(time.substr(2, 4))

      if (h >= 0 && h < 24 && m >= 0 && m < 60)
        return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0')
      else
        return null;

    }
  },
  components: {
    draggable
  }
}
</script>
<style scoped>
.datetime__component {
  display: inline-block;
}
.datetime__component .datetime__date {
  width: 100px;
  display: inline-block;
}
.datetime__component .datetime_time {
  width: 60px;
  display: inline-block;
  top: -2px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/DateTimePicker.vue